/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_Stripe_Warning_TitleInputs */

const fr_admin_subscription_rights_stripe_warning_title = /** @type {(inputs: Admin_Subscription_Rights_Stripe_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement Stripe en cours`)
};

/**

* @param {Admin_Subscription_Rights_Stripe_Warning_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_stripe_warning_title = /** @type {((inputs?: Admin_Subscription_Rights_Stripe_Warning_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Stripe_Warning_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_stripe_warning_title(inputs)
});